// =============================================================================
// src/chrome/copilot-sidebar/tactics-live-store.ts
// Override vivo (Sentinel/AtalaIA) das "Oportunidades táticas — Específicas desta vista".
//
// Quando a hidratação ao vivo traz táticas de gold.ai_action_recommendation
// (action_type='tactical'), liveTacticsForSection() passa a devolver os cards reais da seção; sem
// override, o controller cai no mock estático TACTIC_CARDS_BY_SECTION. O listener deixa o controller
// re-renderizar a seção corrente quando o override chega DEPOIS do init (o fetch Sentinel é async).
// SRP: só estado de override + getter + listener. Sem DOM, sem fetch.
// =============================================================================

import type { SectionId } from '../../app/types';
import type { TacticsBySection } from '../../data/sentinel-overlay';
import type { ViewTacticCard } from './tactic-cards-by-section';

type TacticsLiveListener = () => void;

let liveTactics: TacticsBySection | null = null;
let livePriorities: readonly ViewTacticCard[] | null = null;
let liveListener: TacticsLiveListener | null = null;

/** Cards táticos ao vivo da seção, ou null quando não há override (controller usa o mock). */
export function liveTacticsForSection(section: SectionId): readonly ViewTacticCard[] | null {
  const cards = liveTactics?.[section];
  return cards && cards.length ? cards : null;
}

/** Cards "Prioritárias da campanha" ao vivo, ou null sem override (controller mantém o mock estático). */
export function liveCampaignPriorities(): readonly ViewTacticCard[] | null {
  return livePriorities && livePriorities.length ? livePriorities : null;
}

/** Aplica as prioridades da campanha ao vivo e notifica o controller. Lista vazia = sem override. */
export function applyCampaignPriorities(cards: readonly ViewTacticCard[]): void {
  livePriorities = cards.length ? cards : null;
  liveListener?.();
}

/** Aplica o override e notifica o controller (re-render da seção corrente). Map vazio = sem override. */
export function applyTacticsLiveOverride(override: TacticsBySection): void {
  liveTactics = Object.keys(override).length ? override : null;
  liveListener?.();
}

/** Registra o callback de re-render do controller (substitui o anterior); null desliga. */
export function setTacticsLiveListener(listener: TacticsLiveListener | null): void {
  liveListener = listener;
}

export function __resetTacticsLiveForTests(): void {
  liveTactics = null;
  livePriorities = null;
  liveListener = null;
}
